import { Chip, ChipProps } from '@mui/material'

import { SbpPayment, SbpStatus } from '../../types.ts'
import { EMPTY_VALUE } from '../../constants.ts'

const STATUS_COLORS: Record<SbpStatus, ChipProps['color']> = {
  NEW: 'info',
  REVERSED: 'warning',
  PAID: 'success',
  REJECTED: 'error',
}

const STATUS_TITLES: Record<SbpStatus, string> = {
  NEW: 'Новый',
  REVERSED: 'Возвращён',
  PAID: 'Оплачен',
  REJECTED: 'Отклонён',
}

// у возвратных операций свои статусы
const REVERSE_STATUS_TITLES: Record<SbpStatus, string> = {
  NEW: 'Новый',
  REVERSED: 'Возвращён',
  // для возврата - выполнен
  PAID: 'Выполнен',
  REJECTED: 'Отклонён',
}

export const SbpPaymentStatus = ({ state, type }: { state: SbpPayment['state']; type?: SbpPayment['type'] }) => {
  const label = type === 'REVERSE' ? REVERSE_STATUS_TITLES[state] : STATUS_TITLES[state]
  return state ? (
    <Chip
      label={label}
      color={STATUS_COLORS[state]}
      variant="filled"
      size="small"
      sx={{
        borderRadius: 2,
      }}
    />
  ) : (
    EMPTY_VALUE
  )
}
